import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { switchEndpoint } from '../../../../../redux/actions/endpoints';
import EquipmentTable from './comps';
import { storage } from "../../../../../scopedStorage";

const OperationsComponent = () => {
    const [equipments, setEquipments] = useState([]);
    const [isLoading, setIsloading] = useState(false);
    const [equipmentList, setEquipmentList] = useState([]);

    const fetchEquipments = () => {
        const token = storage.getItem("token");
        setIsloading(true);
        axios
            .get(`${switchEndpoint}/aggregation-center/equipments`, {
        headers: { Authorization: `Bearer ${token}` },
      })
            .then((response) => {
                setIsloading(false);
                setEquipments(response.data);
                toast.success(response?.data?.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "light",
                });
            })
            .catch((error) => {
                setIsloading(false);
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "light",
                });
            });
    };

    useEffect(() => {
        fetchEquipments();
    }, []);

    return (
        <main>
            <div className="main__containersss" style={{ width: "100%", padding: "24px" }}>
                <div className="mb-2">
                    <h4 className="dropOff__title mt-1 mr-4 mb-4">
                    <b>Equipments</b>
                    </h4>
                </div>
                <EquipmentTable isLoading={isLoading} setIsloading={setIsloading} equipments={equipments} />
            </div>
        </main>
    );
};

export default OperationsComponent;